var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "arrow-up-orange_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 12,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.53 9.274a.736.736 0 01-1.06 0L6 4.68 1.53 9.274a.736.736 0 01-1.06 0 .786.786 0 010-1.09L6 2.5l5.53 5.684a.786.786 0 010 1.09z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrow-up-orange_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E95832",
    d: "M0-.001h11.999v12H0z"
  }))));
}
export default __webpack_public_path__ + "static/media/arrow-up-orange.65fe8923.svg";
export { SvgArrowUpOrange as ReactComponent };